/* eslint-disable max-lines */

// TEST EVENTS

export const TEST_EVENT = 'TEST_EVENT';

// GENERICS

/** Triggered usually (but not always) on API errors */
export const GENERIC_ERROR = 'ui:generic:error';
/** Event triggered on success, as a payload, should contain the translation string.
 * Ex. payload = 'v2profile.some.text' which will be translated in the NotificationService.js */
export const GENERIC_SUCCESS = 'ui:generic:success';
/** emits every time url pathname changes, as payload it contains object with previous and current locations */
export const URL_PATHNAME_UPDATED = 'ui:generic:url:pathname:update';
/** emits every time a React component is mounted. Payload example: {component: 'ProfileV2'} */
export const COMPONENT_MOUNT = 'ui:generic:component:mount';
/** emits every time a React component is unmounted. Payload example: {component: 'ProfileV2'} */
export const COMPONENT_UNMOUNT = 'ui:generic:component:unmount';
/** emits every time a JS error is made. */
export const JS_ERROR_CATCH = 'ui:generic:javascript:error';
export const MODAL_CLOSED = 'ui:modal:closed:from:service';

// AWARDS

export const GET_AWARDS_DAILY_WINNERS = 'ui:awards:get:daily:winners';
export const GET_AWARDS_DAILY_WINNERS_RESPONSE = 'ui:awards:get:daily:winners:response';
export const GET_AWARDS_DAILY_WINNERS_ERROR = 'ui:awards:get:daily:winners:error';
export const GET_AWARDS_MONTHLY_WINNERS = 'ui:awards:get:monthly:winners';
export const GET_AWARDS_MONTHLY_WINNERS_RESPONSE = 'ui:awards:get:monthly:winners:response';
export const GET_AWARDS_MONTHLY_WINNERS_ERROR = 'ui:awards:get:monthly:winners:error';
export const GET_AWARDS_RESPONSE = 'ui:awards:get:all:winners:response';

// GALLERIES

export const CREATE_GALLERY = 'ui:galleries:create';
export const CREATE_GALLERY_RESPONSE = 'ui:galleries:create:response';
export const CREATE_GALLERY_ERROR = 'ui:galleries:create:error';

export const GET_GALLERIES = 'ui:galleries:get';
export const GET_GALLERIES_RESPONSE = 'ui:galleries:get:response';
export const GET_GALLERIES_ERROR = 'ui:galleries:get:error';
export const GET_GALLERIES_RESPONSE_STATE = 'ui:galleries:get:galleries:response:state';

export const CREATE_PHOTO = 'ui:galleries:create:photo';
export const CREATE_PHOTO_RESPONSE = 'ui:galleries:create:photo:response';
export const CREATE_PHOTO_ERROR = 'ui:galleries:create:photo:error';

export const GET_PHOTOS = 'ui:galleries:get:photos';
export const GET_PHOTOS_RESPONSE = 'ui:galleries:get:photos:response';
export const GET_PHOTOS_RESPONSE_STATE = 'ui:galleries:get:photos:response:state';
export const GET_GALLERIES_DELETE_PHOTO_STATE = 'ui:galleries:delete:photos:response';

// DMCA

export const SEND_DMCA_TAKEDOWN_REQUEST = 'ui:dmca:send:takedown:request';
export const SEND_DMCA_TAKEDOWN_REQUEST_SUCCESS = 'ui:dmca:send:takedown:request:success';
export const SEND_DMCA_TAKEDOWN_REQUEST_ERROR = 'ui:dmca:send:takedown:request:error';

// STREAMING

export const GET_STREAMING_INFO = 'ui:streaming:info:get';
export const GET_STREAMING_INFO_RESPONSE = 'ui:streaming:info:get:response';
export const GET_STREAMING_INFO_ERROR = 'ui:streaming:info:get:error';
export const USER_BROADCAST_STARTED = 'ui:streaming:user:broadcast:started';
export const UPDATE_STREAM_UUID = 'ui:streaming:update:stream:uuid';
export const STREAM_STARTED = 'ui:streaming:player:playing';
export const STREAM_STARTED_TIPPING_MUTED = 'ui:streaming:player:playing:muted';
/** being emitted when user requests peek streaming */
export const GET_PEEK_STREAMING_INFO = 'ui:streaming:peek:info:get';
/** being emitted streaming info response returned */
export const GET_PEEK_STREAMING_INFO_RESPONSE = 'ui:streaming:peek:info:get:response';
/** being emitted streaming info error returned */
export const GET_PEEK_STREAMING_INFO_ERROR = 'ui:streaming:peek:info:get:error';
export const HLS_RECONNECT = 'ui:streaming:hls:reconnect:stream';
/** triggered when rebuffering is showed on the screen, used by DS team */
export const HLS_REBUFFERING = 'ui:streaming:hls:rebuffering:overlay:show';
/** triggered when a new HSL level is loaded, used by DS team */
export const HLS_LEVEL_LOADED = 'ui:streaming:hls:level_loaded';
export const HLS_DETACH = 'ui:streaming:hls:destroy:stream';
export const HLS_STREAMING_URL_FAILED = 'ui:streaming:hls:url:failed';
export const HLS_DEBUG = 'ui:streaming:hls:debugging';
export const JINK_PLAYER_DEBUG = 'ui:streaming:jink-player:debugging';
export const BUFFERING_OVERLAY = 'ui:streaming:hls:buffering:overlay';
export const RECONNECTING_OVERLAY = 'ui:streaming:hls:reconnecting:overlay';
export const FIREBASE_DEBUG = 'ui:firebase:debugging';
export const FIREBASE_INITIAL_DATA = 'ui:firebase:data:received';
export const SET_STREAMING_JWT_TOKEN = 'ui:set:streaming:jwt:token';
export const NEEDS_ID_MESSAGE_RECEIVED = 'ui:streaming:needsidmessage:received';

// i18n

export const TRANSLATIONS_LOADED = 'ui:i18n:load:success';
export const TRANSLATIONS_LOAD_ERROR = 'ui:i18n:load:error';
export const TRANSLATIONS_KEY_INVALID = 'ui:i18n:key:invalid';
export const TRANSLATIONS_KEY_MISSING = 'ui:i18n:key:missing';

// TIPPING

export const SEND_TIP = 'ui:tipping:send:tip';
export const SEND_TIP_RESPONSE = 'ui:tipping:send:tip:response';
export const SEND_TIP_ERROR = 'ui:tipping:send:tip:error';
export const SEND_TIP_ERROR_FUNDS = 'ui:tipping:send:tip:error:funds';
export const SEND_PRIVATE_TIP = 'ui:tipping:send:private:tip';
export const SEND_PRIVATE_TIP_RESPONSE = 'ui:tipping:send:private:tip:response';
export const SEND_PRIVATE_TIP_ERROR = 'ui:tipping:send:private:tip:error';
export const SEND_PRIVATE_TIP_INSUFFICIENT_FUNDS = 'ui:tipping:send:private:tip:insufficient:funds';
export const GET_PERFORMER_TIPPING_SESSION = 'ui:tipping:get:performer:session:response';
export const GET_PERFORMER_TIPPING_SESSION_ERROR = 'ui:tipping:get:performer:session:error';
export const UPDATE_BALANCE = 'ui:tipping:update:balance';
export const INITIATE_SEND_TIP = 'ui:tipping:initiate:send:tip';
export const GET_TIPPING_INFO = 'ui:tipping:get:tip:response';
export const TIPPING_INFO_ERROR = 'ui:tipping:tipping:info:error';
export const SEND_TIP_RESPONSE_STATUS = 'ui:send:tip:response:state';
export const UPDATE_ANONYMOUS_TIPPING_HASH = 'ui:update:anonymous:tipping:hash';
export const SET_PERFORMER_GOAL_MESSAGE = 'ui:update:perfomer:goal:message';

// TAGS

export const GET_SPONSORED_TAGS_LIST = 'ui:tags:sponsored:get:list';
export const GET_SPONSORED_TAGS_LIST_RESPONSE = 'ui:tags:sponsored:get:list:response';
export const GET_SPONSORED_TAGS_LIST_ERROR = 'ui:tags:sponsored:get:list:error';
export const CHANGE_SPONSORED_TAG_SWITCH_STATUS = 'ui:tags:sponsored:change:switch:status';
export const CHANGE_SPONSORED_TAG_SWITCH_STATUS_RESPONSE = 'ui:tags:sponsored:change:active:status:response';
export const CHANGE_SPONSORED_TAG_SWITCH_STATUS_ERROR = 'ui:tags:sponsored:change:active:status:error';
export const CREATE_SPONSORED_TAG = 'ui:tags:sponsored:create:new:tag';
export const CREATE_SPONSORED_TAG_RESPONSE = 'ui:tags:sponsored:create:new:tag:response';
export const CREATE_SPONSORED_TAG_ERROR = 'ui:tags:sponsored:create:new:tag:error';
export const GET_BROADCASTERS_LIST_FOR_TAG = 'ui:tags:sponsored:get:broadcasters:list:for:tag';
export const GET_BROADCASTERS_LIST_FOR_TAG_RESPONSE = 'ui:tags:sponsored:get:broadcasters:list:for:tag:response';
export const GET_BROADCASTERS_LIST_FOR_TAG_ERROR = 'ui:tags:sponsored:get:broadcasters:list:for:tag:error';
export const REMOVE_BROADCASTER_USING_SPONSORED_TAG = 'ui:tags:sponsored:remove:broadcaster:using:tag';
export const REMOVE_BROADCASTER_USING_SPONSORED_TAG_RESPONSE =
  'ui:tags:sponsored:remove:broadcaster:using:tag:response';
export const REMOVE_BROADCASTER_USING_SPONSORED_TAG_ERROR = 'ui:tags:sponsored:remove:broadcaster:using:tag:error';
export const ADD_BROADCASTER_TO_SPONSORED_TAG = 'ui:tags:sponsored:add:broadcaster:to:tag';
export const ADD_BROADCASTER_TO_SPONSORED_TAG_RESPONSE = 'ui:tags:sponsored:add:broadcaster:to:tag:response';
export const ADD_BROADCASTER_TO_SPONSORED_TAG_ERROR = 'ui:tags:sponsored:add:broadcaster:to:tag:error';
export const ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG = 'ui:tags:sponsored:add:studio:broadcaster:to:tag';
export const ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_RESPONSE =
  'ui:tags:sponsored:add:studio:broadcaster:to:tag:response';
export const ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_ERROR = 'ui:tags:sponsored:add:studio:broadcaster:to:tag:error';
export const DELETE_SPONSORED_TAG = 'ui:tags:sponsored:add:delete:tag';
export const DELETE_SPONSORED_TAG_RESPONSE = 'ui:tags:sponsored:add:delete:tag:response';
export const DELETE_SPONSORED_TAG_ERROR = 'ui:tags:sponsored:add:delete:tag:error';
export const PREDEFINED_TAGS_RESPONSE = 'ui:tags:predefined:tags:response';
export const SET_TAGS_FROM_BROADCASTER_SETTINGS_AND_GET_PREDEFINED_TAGS =
  'ui:set:chosen:tags:from:broadcaster:settings:and:get:predefined:tags';

// GAMES

export const GET_ACTIVE_GAMES_INFO = 'ui:games:get:active:games:info';
export const GET_ACTIVE_GAME_INFO_RESPONSE = 'ui:games:get:active:games:response';
export const GET_ACTIVE_GAME_INFO_ERROR = 'i:games:get:active:games:error';
export const SPIN_THE_WHEEL_ROLL = 'ui:games:spin:the:wheel:roll';
export const SPIN_THE_WHEEL_ROLL_RESPONSE = 'ui:games:spin:the:wheel:roll:response';
export const SPIN_THE_WHEEL_ROLL_ERROR = 'ui:games:spin:the:wheel:roll:error';
export const SPIN_THE_WHEEL_INFO = 'ui:games:spin:the:wheel:info';
export const SPIN_THE_WHEEL_INFO_RESPONSE = 'ui:games:spin:the:wheel:info:response';
export const TOKEN_KENO_CLICK = 'ui:games:token:keno:click';
export const GET_GAME_INFO = 'ui:games:game:info';
export const GAME_INFO_RESPONSE = 'ui:games:game:info:response';
export const PLAY_RESPONSE = 'ui:games:play:response';
export const TIP_MENU_STOP = 'ui:games:tipMenu:stop';
export const TIP_MENU_START = 'ui:games:tipMenu:start';
export const GAME_RESUMED = 'ui:games:game:resumed';
export const GAME_RESUME_ERROR = 'ui:games:game:resume:error';

/** GamesStore is setting the new game info once this is triggered */
export const UPDATE_CURRENT_GAME = 'ui:games:game:update:current:game:action';
/** GamesStore is setting the new game info once this is triggered */
export const CLEAR_GAME_RESULT = 'ui:games:game:clear:game:result';
export const GET_ACTIVE_GAME_INFO_TRIGGER = 'ui:games:game:get:active:game:info:trigger';

// SILENCE AND BANS

export const GET_SILENCE_LIST = 'ui:silence:get:list';
export const GET_SILENCE_LIST_RESPONSE = 'ui:silence:get:silence:list:response';
export const GET_SILENCE_LIST_ERROR = 'ui:silence:get:silence:list:error';
export const GET_SILENCE_USER_RESPONSE_STATUS = 'ui:silence:get:user:response:status';
export const SILENCE_USER = 'ui:silence:user';
export const SILENCE_OR_BAN_USER_AS_MODERATOR = 'ui:silence:user:as:room:moderator';
export const REPORT_USER = 'ui:report:user';
export const GET_REPORT_USER_INFO = 'ui:report:get:user:info';
export const GET_REPORT_USER_INFO_RESPONSE = 'ui:report:get:user:info:response';
export const GET_REPORT_USER_INFO_RESPONSE_STATUS = 'ui:report:get:user:infor:response:status';
export const GET_REPORT_USER_RESPONSE_STATUS = 'ui:report:get:user:response:status';
export const USER_HAS_BEEN_KICKED_OR_BANNED = 'ui:kick:request:response';
export const PERFORMER_HAS_BEEN_FEATURED = 'ui:feature:request:response';
export const ROOM_HAS_BEEN_CLOSED = 'ui:close:request:response';

// PRIVATE SHOWS

export const PRIVATE_SHOW_REQUEST_SENT = 'ui:privateShow:request:sent';
/** event which is being trigger when private show request expires (2 minutes after being sent) */
export const PRIVATE_SHOW_REQUEST_EXPIRED = 'ui:privateShow:request:expired';
export const REQUEST_PLAY_TOKEN = 'ui:privateShow:request:play:token';
export const PRIVATE_SHOW_STOP_PS = 'ui:privateShow:stop:ps';
export const PRIVATE_SHOW_STOP_SPY = 'ui:privateShow:stop:spy';
export const REJOIN_SPY_SHOW_ERROR = 'ui:rejoin:spy:show:error';
export const SET_IS_PRIVATE_SHOW_REQUESTING_TO_END = 'ui:privateShow:request:stop';
export const SET_ACCEPTED_PENDING_USER_FOR_PRIVATE_SHOW = 'ui:set:accepted:pending:user:for:private:show';

// DIRECTORY

export const DIRECTORY_THUMBNAIL_CLICK = 'ui:directory:thumbnail:click';

// PROFILE

export const INITIATE_PRIVATE_MESSAGE = 'ui:tipping:initiate:private:message';
export const PROFILE_PRIVATE_MESSAGE_SENT = 'ui:profile:private:message:sent';
export const SEND_ACCESS_FILE_URL = 'ui:profile:send:access:file:url';
export const GET_SIMILAR_CAMS = 'ui:profile:get:similar:cams';
export const WISHLIST_INFO = 'ui:profile:wishlist:info';
export const WISHLIST_INFO_RESPONSE = 'ui:profile:wishlist:info:response';
export const GET_USER_FRIENDS = 'ui:profile:get:user:friends';
export const GET_USER_FRIENDS_RESPONSE = 'ui:profile:get:user:friends:response';
export const REINIT_ROOM = 'ui:profile:reinit:room';
export const GET_PLAY_TOKEN_FOR_GROUP_SHOW = 'ui:stream:group:show:token:get';
/** room state received from firebase (once on page init plus anytime something changes) */
export const ROOM_STATE_CHANGED_RESPONSE = 'ui:profile:room:state:changed:response';
export const GET_SEX_QUESTIONNAIRE = 'ui:profile:get:sex:questionnaire';
export const GET_SEX_QUESTIONNAIRE_RESPONSE = 'ui:profile:get:sex:questionnaire:response';
export const UPDATE_WEB_PRESENCE_CHAT_STATUS = 'ui:profile:update:web:presence:chat:status';
export const RESET_PRIVATE_ROOM = 'ui:profile:reset:private:room';
export const POST_FEEDBACK_V2_PROFILE_RESPONSE_STATUS = 'ui:profile:post:feedback:v2:profile:response:status';
export const GET_FEATURED_CAM_STATS = 'ui:profile:get:featured:cam:stats';
export const SET_GENDER_PREFERENCE = 'ui:profile:set:gender:preference';
export const OPEN_TIP_MENU_DRAWER = 'ui:profile:open:tip:menu:drawer';
export const PROFILE_CONTROLLED_FEATURES = 'ui:profile:profile:cf:response';

// FANCLUB NEW
export const FANCLUB_USER_LOGGED_IN = 'ui:fanclub:user:login';
export const USER_JOINED_FANCLUB_NOTIFICATION = 'ui:fanclub:user:subscribe';

// FANCLUB

export const GET_PERFORMER_FAN_CLUB_INFO = 'ui:fanclub:info';
export const GET_PERFORMER_FAN_CLUB_INFO_RESPONSE = 'ui:fanclub:info:response';
export const GET_PERFORMER_FAN_CLUB_INFO_ERROR = 'ui:fanclub:info:error';

// GIFTS

/** invocation to trigger the retrival of the gift categories */
export const GET_GIFT_CATEGORIES_LIST = 'ui:gifts:categories:response';
/** response for get gift categories, used in Gifts section (Profile/Gifts Showcase, Gifts) */
export const GET_GIFT_CATEGORIES_LIST_RESPONSE = 'ui:gifts:categories:data:response';
/** error handler for failed get call for categories */
export const GET_GIFT_CATEGORIES_LIST_ERROR = 'ui:gifts:categories:data:error';
/** invocation to trigger the retrival of the gifts */
export const GET_GIFT_LIST = 'ui:gifts:response';
/** response for get gift list, used in Gifts section (Profile/Gifts Showcase, Gifts) */
export const GET_GIFT_LIST_RESPONSE = 'ui:gifts:data:response';
/** error handler for failed get call for gifts */
export const GET_GIFT_LIST_ERROR = 'ui:gifts:data:error';
/** response for adding new category */
export const ADD_CATEGORY_RESPONSE = 'ui:gifts:add:category:response';
/** response for adding new gift */
export const ADD_GIFT_RESPONSE = 'ui:gifts:add:gift:response';
/** response for getting gift by id */
export const SINGLE_GIFT_RESPONSE = 'ui:gifts:single:gift:response';
/** response for all admin categories */
export const GET_ADMIN_CATEGORIES_LIST_RESPONSE = 'ui:admin:categories:response';
/** trigerred on failed request for admin categories */
export const GET_ADMIN_CATEGORIES_LIST_ERROR = 'ui:admin:categories:error';
/** response for adming gifts */
export const GET_ADMIN_GIFT_LIST_RESPONSE = 'ui:admin:gifts:response';
/** error for adming gifts */
export const GET_ADMIN_GIFT_LIST_ERROR = 'ui:admin:gifts:error';
/** fired when creating temporary url for image is successful */
export const TMP_IMAGE_RESPONSE = 'ui:admin:tmp:image:response';
/** response for single admin category */
export const GET_ADMIN_SINGLE_CATEGORY_RESPONSE = 'ui:admin:single:category:response';
/** fired when get for single category fails */
export const GET_ADMIN_SINGLE_CATEGORY_ERROR = 'ui:admin:single:category:error';
/** Trigger the send gift API */
export const SEND_GIFT = 'ui:gifts:send:gift:trigger';
/** fired on successfull gift send */
export const SEND_GIFT_SUCCESS = 'ui:gifts:send:gift:success';
/** fired on failed gift send request */
export const SEND_GIFT_ERROR = 'ui:gifts:send:gift:error';
/** Trigger the giftapi/categories/gifts API */
export const GET_GIFTS_BY_CATEGORIES = 'ui:gifts:get:gifts:by:category:trigger';
/** returns the categories list with embedded gifts upon successfull API call */
export const GET_GIFTS_BY_CATEGORIES_SUCCESS = 'ui:gifts:get:gifts:by:category:success';
/** fired on failed get gifts by category request */
export const GET_GIFTS_BY_CATEGORIES_ERROR = 'ui:gifts:get:gifts:by:category:error';
/** Triggered to get the data for populating the quick gift send modal */
export const GET_QUICK_GIFTS_DATA = 'ui:gifts:quick:get:gifts';
/** Triggered on successfull data retrieved (see GET_QUICK_GIFTS_DATA); */
export const GET_QUICK_GIFTS_DATA_SUCCESS = 'ui:gifts:quick:get:gifts:success';
/** Triggered on errors when retrieving data (see GET_QUICK_GIFTS_DATA); */
export const GET_QUICK_GIFTS_DATA_ERROR = 'ui:gifts:quick:get:gifts:error';
/** Triggered when calling for one of the gifts sorting option */
export const GET_SORTED_GIFTS = 'ui:gifts:get:sorted:gifts';
/** Triggered when receive sorted gifts from be */
export const GET_SORTED_GIFTS_RESPONSE = 'ui:gifts:get:sorted:gifts:response';
/** Triggered when failing to get response */
export const GET_SORTED_GIFTS_ERROR = 'ui:gifts:get:sorted:gifts:error';
/** response for gifting history */
export const GIFTING_HISTORY_RESPONSE = 'ui:gifts:gifting:history:response';
/** Triggered when adding/editing gift fails */
export const ADD_GIFT_ERROR = 'ui:gifts:add:gift:error';
/** Trigerred when adding/editing category fails */
export const ADD_CATEGORY_ERROR = 'ui:gifts:add:category:error';
/** Response when searching gifts */
export const GIFTS_SEARCH_RESPONSE = 'ui:gifts:gifts:search:response';
/** Triggered on gifts search error */
export const GIFTS_SEARCH_ERROR = 'ui:gifts:gifts:search:error';
/** Trigerred when geting single category fails */
export const GET_SINGLE_CATEGORY_ERROR = 'ui:gifts:get:single:category:error';
/** Response for single category */
export const GET_SINGLE_CATEGORY_RESPONSE = 'ui:gifts:get:single:category:response';
/** Response for gold gifts */
export const SET_GOLD_GIFTS_DATA_SUCCESS = 'ui:gifts:set:gold:gifts:success';
/** Triggered for gold gifts error */
export const GET_GOLD_GIFTS_DATA_ERROR = 'ui:gifts:get:gold:gifts:error';
/** Response for admin only gifts */
export const ADMIN_ONLY_GIFTS_RESPONSE = 'ui:gifts:admin:only:gifts:response';
/** Response for sending mass gift */
export const SEND_MASS_GIFT_RESPONSE = 'ui:gifts:send:mass:gifts:response';
/** Error for sending mass gift */
export const SEND_MASS_GIFT_ERROR = 'ui:gifts:send:mass:gifts:error';

// REDUX LEGACY MODAL TRIGGERS

export const SHOW_REGISTRATION_MODAL = 'ui:modals:registration:show';
export const HIDE_REGISTRATION_MODAL = 'ui:modals:registration:hide';
export const SHOW_UPGRADE_TO_GOLD_MODAL = 'ui:modals:upgradeToGold:show';
export const HIDE_UPGRADE_TO_GOLD_MODAL = 'ui:modals:upgradeToGold:hide';

// GROUP SHOW

export const BUY_GROUP_SHOW_TICKET_RESPONSE = 'ui:buy:group:show:ticket:response';
export const REMAINING_TIME_UNTIL_GROUP_SHOW = 'ui:group:show:remaining:time';
export const CONNECT_TO_GROUP_SHOW_CHAT = 'ui:group:show:connect:to:chat';

// FIREBASE

export const FIREBASE_NEW_MAIN_CHAT_MESSAGE = 'ui:firebase:new:main:chat:message';

export const FIREBASE_UNAVAILABLE = 'ui:firebase:unavailable';
export const FB_SET_AUTH_DATA = 'ui:firebase:set:auth:data';
export const MODERATOR_PRIVILEGE_CHANGED = 'ui:firebase:moderator:privilege:changed';
/** setting jwt token */
export const SET_JWT_TOKEN = 'ui:set:jwt:token';

// USER

export const GET_USER_DATA_RESPONSE = 'ui:user:get:user:data:response';
export const SET_USER_GENDER_PREFERENCE = 'ui:user:set:gender:preference';

export const GET_USER_CONSENT_STATUS = 'ui:user.get:consent:status';
export const GET_USER_CONSENT_STATUS_RESPONSE = 'ui:user.get:consent:status:response';
export const GET_USER_CONSENT_STATUS_ERROR = 'ui:user.get:consent:status:error';

export const SET_RESEND_EMAIL_RESPONSE = 'ui:user:set:resend:email:response';
export const RESEND_EMAIL_RESPONSE_ERROR = 'ui:user:resend:email:error';
export const TOGGLE_VERSION_UPDATE = 'ui:user:toggle:update:version';
/** when login is successful */
export const LOGIN_SUCCESS = 'ui:user:login:success';
/** when login has error other than 403 */
export const LOGIN_ERROR = 'ui:user:login:error';
/** when login has error 403 with data for next action */
export const LOGIN_ERROR_403 = 'ui:user:login:error:403';

export const GET_USER_INFO_RESPONSE = 'ui:get:user:info:response';
export const GET_USER_INFO_ERROR = 'ui:get:user:info:error';

export const USER_LOGGED_OUT = 'ui:user:logged:out';
export const USER_LOGGED_OUT_ERROR = 'ui:user:logged:out:error';
export const USER_LOGGED_OUT_PENDING = 'ui:user:toggle:logged:out';

/** when login with security questions is successful */
export const LOGIN_WITH_SECURITY_QUESTION_ERROR = 'ui:user:login:security:questions:error';
/** when login with security questions has 403 error with information */
export const LOGIN_WITH_SECURITY_QUESTION_ERROR_403 = 'ui:user:login:security:questions:error:403';

/** when password reset is successful */
export const PASSWORD_RESET_EMAIL_RESPONSE = 'ui:user:password:reset:email:response';
/** when password reset has error 404 or 500 */
export const PASSWORD_RESET_EMAIL_ERROR = 'ui:user:password:reset:email:error';
/** when password reset has error 400 */
export const PASSWORD_RESET_EMAIL_ERROR_400 = 'ui:user:password:reset:email:error:400';
/**  when password reset has error 403 */
export const PASSWORD_RESET_EMAIL_ERROR_403 = 'ui:user.password:reset:email:error:403';
/** when password reset has error 429 (to many requests) */
export const PASSWORD_RESET_EMAIL_ERROR_429 = 'ui:user:password:reset:email:error:429';

/** when password change is successful */
export const PASSWORD_CHANGE_RESPONSE = 'ui:user:password:change:response';
/** when password change has 404 or 500 error */
export const PASSWORD_CHANGE_ERROR = 'ui:user:password:change:error';
/** when password change has 400 error with information */
export const PASSWORD_CHANGE_ERROR_400 = 'ui:user:password:change:error:400';
/** when password change has 403 error with information */
export const PASSWORD_CHANGE_ERROR_403 = 'ui:user:password:change:error:403';

/** when password reset is successful */
export const PASSWORD_RESET_RESPONSE = 'ui:user:password:reset:response';
/** when password reset has 404 or 500 error */
export const PASSWORD_RESET_ERROR = 'ui:user:password:reset:error';
/** when password reset has 400 error with information */
export const PASSWORD_RESET_ERROR_400 = 'ui:user:password:reset:error:400';
/** when password reset has 403 error with information */
export const PASSWORD_RESET_ERROR_403 = 'ui:user:password:reset:error:403';

/** when verify 2fa code is successful */
export const VERIFY_2FA_CODE_RESPONSE = 'ui:user:verify:2fa:code:response';
/** when verify 2fa code has error */
export const VERIFY_2FA_CODE_ERROR = 'ui:user:verify:2fa:code:error';
/** when verify 2fa code has error 403 */
export const VERIFY_2FA_CODE_ERROR_403 = 'ui:user:verify:2fa:code:error;403';

/** when resend 2fa code is successful */
export const RESEND_2FA_CODE_RESPONSE = 'ui:user:resend:2fa:code:response';
/** when resend 2fa code has error */
export const RESEND_2FA_CODE_ERROR = 'ui:user:resend:2fa:code:error';
/** when resend 2fa code has error 403 */
export const RESEND_2FA_CODE_ERROR_403 = 'ui:user:resend:2fa:code:error:403';

export const SEND_USER_FEEDBACK_MODAL = 'ui:user:send:feedback:modal';

// PRIVATE DIRECTORY

export const GET_PRIVATE_DIRECTORY_CAMS = 'ui:privateDirectory:get:cams';
/** invocation to trigger the retrival of the private directory cams */
export const GET_PRIVATE_DIRECTORY_CAMS_RESPONSE = 'ui:privateDirectory:get:cams:response';
/** when api for ppd returns error */
export const GET_PRIVATE_DIRECTORY_CAMS_ERROR = 'ui:privateDirectory:get:cams:error';

export const GET_PRIVATE_DIRECTORY_CAROUSEL_CAMS = 'ui:privateDirectory:get:carousel:cams';
/** getting the slider / carousel cams response */
export const GET_PRIVATE_DIRECTORY_CAROUSEL_CAMS_RESPONSE = 'ui:privateDirectory:get:carousel:cams:response';
/** triggers when API for slider / carousel cams returns an errors */
export const GET_PRIVATE_DIRECTORY_CAROUSEL_CAMS_ERROR = 'ui:privateDirectory:get:carousel:cams:error';

/** invocation to trigger the retrival for the ppd filters */
export const GET_PRIVATE_DIRECTORY_FILTERS_RESPONSE = 'ui:privateDirectory:get:filters:response';
/** triggers when the API for filters returns an error */
export const GET_PRIVATE_DIRECTORY_FILTERS_ERROR = 'ui:privateDirectory:get:filters:error';

/** invocation to trigger the retrival for the ppd kinks */
export const GET_PRIVATE_DIRECTORY_KINKS_RESPONSE = 'ui:privateDirectory:get:kinks:response';
/** triggers when the API for kinks returns an error */
export const GET_PRIVATE_DIRECTORY_KINKS_ERROR = 'ui:privateDirectory:get:kinks:error';

export const GET_PRIVATE_DIRECTORY_USER_PRIVATE_SHOW_SETTINGS =
/** invocation to trigger the retrival for the private show settings from the broadcaster
 * (which user wants to send the PS request) */
'ui:privateDirectory:get:userPrivateShowSettings:response';
export const GET_PRIVATE_DIRECTORY_USER_PRIVATE_SHOW_SETTINGS_ERROR =
/** triggers when the API for user private show settings returns an error */
'ui:privateDirectory:get:userPrivateShowSettings:error';

/** invocation to trigger sending the PS request to the broadcaster (offline request) */
export const PRIVATE_DIRECTORY_PRIVATE_SHOW_SENT = 'ui:privateDirectory:get:postResponse:response';
/** triggers when user wants to cancel the PS request */
export const PRIVATE_DIRECTORY_PRIVATE_SHOW_CANCEL = 'ui:privateDirectory:cancel:privateShow';

/** triggers in firebase (userNotification node), when broadcaster accepts the PS request */
export const PRIVATE_DIRECTORY_USER_NOTIFICATION = 'ui:privateDirectory:userNotification';
/** triggers in firebase (userNotification node), when broadcaster changes his PS settings */
export const PRIVATE_DIRECTORY_USER_NOTIFICATION_CHANGED = 'ui:privateDirectory:userNotificationChanged';
/** triggers in firebase (userNotification node), when broadcaster goes offline */
export const PRIVATE_DIRECTORY_ROOM_OFFLINE = 'ui:privateDirectory:roomOffline';

/** retriving the user balance */
export const PRIVATE_DIRECTORY_USER_BALANCE = 'ui:privateDirectory:userBalance';

// PAYMENT

export const GET_AUTOBILLING_STATUS = 'ui:payment:aubilling:status';
export const GET_AUTOBILLING_STATUS_RESPONSE = 'ui:payment:autobilling:status:response';
export const GET_AUTOBILLING_STATUS_ERROR = 'ui:payment:autobilling:status:error';
export const AUTOBILLING_OPTIN = 'ui:payment:autobilling:optin';
export const AUTOBILLING_OPTIN_RESPONSE = 'ui:payment:autobilling:optin:response';
export const AUTOBILLING_OPTIN_ERROR = 'ui:payment:autobilling:optin:error';
export const TRIGGER_AUTOBILLING = 'ui:payment:autobilling:trigger';
export const TRIGGER_AUTOBILLING_RESPONSE = 'ui:payment:autobilling:trigger:response';
export const TRIGGER_AUTOBILLING_ERROR = 'ui:payment:autobilling:trigger:error';
/** Triggers an action that will show the buy tokens modal, currently intercepted via redux. */
export const SHOW_BUY_TOKENS_MODAL_TRIGGER = 'ui:payment:show:buy:tokens:modal';
// emitted from redux, used by ABTests to track when the buy tokens modal is shown
export const BUY_TOKENS_MODAL_SHOWN = 'ui:payment:buy:tokens:modal:shown';
// receiving a signal to show token awareness modal, emitted mostly from the vwo-side
export const PAYMENT_TOKEN_AWARENESS_TRIGGER = 'ui:payment:show:token:awareness';

// GIPHY GIFS

/** retriving event for search/trending gifs */
export const GET_GIFS_RESPONSE = 'ui:gifs:get:response';
/** changing the search/trending gifs status of endpoint(pending, loaded, error) */
export const GET_GIFS_RESPONSE_STATUS = 'ui:gifs:get:response:status';

// CHATWALL

export const GET_CHAT_WALL_COMMENTS = 'ui:chat:wall:get:comments';
export const DELETE_COMMENT_RESPONSE_STATE = 'ui:chat:wall:delete:comment:response:status';
export const GET_CHAT_WALL_VISIBILITY = 'ui:chat:wall:visibility:state';

// CHAT - USERLIST TAB IN PROFILE

export const UPDATE_USER_COUNT_LIGHT = 'ui:chat:get:users';

// ADMIN - LANGUAGE IN PERFORMANCE ALGORITHM

export const GET_ADMIN_USER_IGNORED_COUNTRY = 'ui:admin:user:get:ignoredCountry';
export const ADMIN_USER_IGNORED_COUNTRY_ERROR = 'ui:admin:user:get:ignoredCountry:error';

export const GET_ADMIN_LANGUAGES_DIRECTORY_FILTERS = 'ui:admin:language:get:directoryFilters';
export const GET_ADMIN_LANGUAGES_DIRECTORY_FILTERS_ERROR = 'ui:admin:language:get:directoryFilters:error';
export const GET_CS_LANGUAGE_OVERRIDES = 'ui:admin:language:get:csOverrides';
export const GET_CS_LANGUAGE_OVERRIDES_ERROR = 'ui:admin:language:get:csOverrides:error';
export const GET_USER_LANGUAGE_DATA = 'ui:admin:language:get:userLanguageData';
export const GET_USER_LANGUAGE_DATA_ERROR = 'ui:admin:language:get:userLanguageData:error';
export const ADD_CS_LANGUAGE_OVERRIDE_ERROR = 'ui:admin:language:add:csOverride:error';
export const DELETE_CS_LANGUAGE_OVERRIDE_ERROR = 'ui:admin:language:delete:csOverride:error';

export const GET_CS_COUNTRY_OVERRIDES = 'ui:admin:country:get:csOverrides';
export const GET_CS_COUNTRY_OVERRIDES_ERROR = 'ui:admin:country:get:csOverrides:error';
export const ADD_CS_COUNTRY_OVERRIDE_ERROR = 'ui:admin:country:add:csOverride:error';
export const UPDATE_CS_COUNTRY_OVERRIDE_ERROR = 'ui:admin:country:update:csOverride:error';
export const DELETE_CS_COUNTRY_OVERRIDE_ERROR = 'ui:admin:country:delete:csOverride:error';

// ADMIN - LOGS

export const GET_ADMIN_AUTOMATED_LOGS = 'ui:admin:automated:logs';
export const GET_ADMIN_AUTOMATED_LOGS_ERROR = 'ui:admin:automated:logs:error';

export const GET_ADMIN_MANUAL_LOGS = 'ui:admin:manual:logs';
export const GET_ADMIN_MANUAL_LOGS_ERROR = 'ui:admin:manual:logs:error';

// BOOST

export const BOOST_CAM_RESPONSE = 'ui:boost:cam:response';
export const BOOST_CAM_ERROR = 'ui:boost:cam:error';

// VIDEO METRICS

export const UPDATE_VIDEO_METRICS = 'ui:video:metrics';

// MY LIBRARY

export const GET_LIBRARY_VIDEOS = 'ui:my:library:get:videos';
export const GET_LIBRARY_VIDEOS_RESPONSE = 'ui:my:library:get:videos:response';
export const GET_LIBRARY_VIDEOS_RESPONSE_STATUS = 'ui:my:library:get:videos:response:status';
export const GET_LIBRARY_VIDEOS_NUMBER = 'ui:my:library:get:videos:number';
export const GET_PLAY_URL_RESPONSE = 'ui:my:library:get:play:url:response';
export const GET_NEXT_VIDEO = 'ui:my:library:get:next:video';
export const UPDATE_PLAYING_STATUS = 'ui:my:library:update:playing:status';
export const SEND_VIDEO_METRICS = 'ui:video:send:metrics';
export const SEND_HLS_VIDEO_EVENTS = 'ui:video:hls:send:events';

// CALENDAR EVENTS

/** Fetch show dates for both performer and subscribed broadcasters */
export const GET_DATES = 'ui:get:dates';
/** Calendar show schedules response */
export const GET_DATES_RESPONSE = 'ui:get:dates:response';
/** Calendar show schedules errors */
export const GET_DATES_ERROR = 'ui:get:dates:error';
/** Calendar schedule delete in progress */
export const CALENDAR_SCHEDULE_DELETE_IN_PROGRESS = 'ui:calendar:schedule:delete:in:progress';
/** Calendar schedule deleted successfully */
export const CALENDAR_SCHEDULE_DELETE_RESPONSE = 'ui:calendar:schedule:delete:response';
/** Calendar schedule delete error */
export const CALENDAR_SCHEDULE_DELETE_ERROR = 'ui:calendar:schedule:delete:error';
/** Export calendar error */
export const EXPORT_CALENDAR_CONTENT_ERROR = 'ui:export:calendar:content:error';
/** Create schedule in progress */
export const CALENDAR_CREATE_SCHEDULE_IN_PROGRESS = 'ui:calendar:create:schedule:in:progress';
/** Create schedule success */
export const CALENDAR_CREATE_SCHEDULE_RESPONSE = 'ui:calendar:create:schedule:response';
/** Create schedule error */
export const CALENDAR_CREATE_SCHEDULE_ERROR = 'ui:calendar:create:schedule:error';
/** Update schedule in progress */
export const CALENDAR_UPDATE_SCHEDULE_IN_PROGRESS = 'ui:calendar:update:schedule:in:progress';
/** Update schedule success */
export const CALENDAR_UPDATE_SCHEDULE_RESPONSE = 'ui:calendar:update:schedule:response';
/** Update schedule error */
export const CALENDAR_UPDATE_SCHEDULE_ERROR = 'ui:calendar:update:schedule:error';
/** Get calendar subscribers count */
export const CALENDAR_GET_SUBSCRIBED_COUNT = 'ui:calendar:get:subscripted:count';
/** Get online friends & favorites for logged in user */
export const ONLINE_FRIENDS_FAVORITES = 'ui:get:online:friends:favorites';
/** Get online friends & favorites count for logged in user */
export const ONLINE_FRIENDS_FAVORITES_COUNT = 'ui:get:online:friends:favorites:count';
/** Get online friends for logged in user */
export const ONLINE_FRIENDS = 'ui:get:online:friends';
/** Get online favorites count for logged in user */
export const ONLINE_FAVORITES = 'ui:get:online:favorites';

// FRIENDS&FAVORITES
// export const FRIENDS_PRESENCE_RESPONSE = 'ui:friends:get:presence'; //response for friends online presence
// export const FAVORITES_PRESENCE_RESPONSE = 'ui:favorites:get:presence'; //response for favorites online presence
export const TOGGLE_FAVORITES = 'ui:favorites:toggle';
export const TOGGLE_FRIENDS = 'ui:friends:toggle';

// ANALYTICS

/** Room initialization completed. Fired for re-init also */
export const UI_ANALYTICS_ROOM_INIT = 'ui:analytics:profile:room:init';

// BROADCASTER CASHOUT

export const RESET_DIRECT_DEPOSIT_CA = 'ui:broadcaster:cashout:reset:directDepositCA';

// CASHOUT STATUS

/** retrieving user cashout status */
export const CASHOUT_STATUS_RESPONSE = 'ui:cashout:status:response';
/** retrieving studio roster */
export const STUDIO_ROSTER_RESPONSE = 'ui:studio:roster:response';
export const STUDIO_PERFORMER_RESPONSE = 'ui:studio:performer:response';

// BROADCASTER

/** show ended */
export const SHOW_ENDED = 'ui:broadcast:end';
/** response for retrieving broadcast end error */
export const END_BROADCAST_ERROR = 'ui:broadcast:end:error';
/** response for retrieving user broadcast settings */
export const USER_BROADCAST_SETTINGS_RESPONSE = 'ui:user:broadcast:settings:response';
/** error for retrieving user broadcast settings */
export const USER_BROADCAST_SETTINGS_ERROR = 'ui:user:broadcast:settings:error';
/** response on devices received from JINK */
export const BROADCASTER_DEVICES_RECEIVED = 'ui:broadcaster:devices:received';
/** response for init streaming room */
export const INIT_STREAMING_ROOM_RESPONSE = 'ui:init:streaming:room:response';
/** setting stream object from JINK */
export const BROADCASTER_SET_STREAM_OBJECT = 'ui:broadcaster:set:stream:object';
/** settings stream aspect ratio; */
export const BROADCASTER_ASPECT_RATION_SET_RESPONSE = 'ui:broadcaster:set:aspect:ratio';
/** setting fps that we get from JINK */
export const SET_FPS_FROM_JINK = 'ui:broadcaster:set:fps:from:jink';
/** set video loading */
export const SET_BROADCASTER_VIDEO_LOADING = 'ui:broadcaster:set:video:loading';
/** starting broadcast response */
export const START_BROADCAST_RESPONSE = 'ui:broadcaster:start:broadcast';
/** int value we receive for mic volume level */
export const MIC_LEVEL_VALUE = 'ui:broadcaster:mic:level:value';
/** the boolean value event emitted after checking if user has multiple identities. */
export const USER_HAS_MULTIPLE_IDENTITIES = 'ui:broadcaster:multiple:identities:response';
/** setting the broadcaster password value */
export const SET_BROADCASTER_PRIVATE_ROOM_PASSWORD = 'ui:broadcaster:set:private:room:password';
export const CLOSE_PRIVATE_ROOM_DRAWER = 'ui:broadcaster:close:private:room:drawer';
/** boolean value for hd res streaming */
export const BROADCASTING_IN_HD = 'ui:broadcster:resolution:hd';
/** response for stream key */
export const STREAM_KEY_RESPONSE = 'ui:broadcaster:get:stream:key';
/** response for updating pause status */
export const PAUSE_STATUS_SUCCESS = 'ui:broadcaster:update:pause:status:success';
/** error for updating pause status */
export const PAUSE_STATUS_ERROR = 'ui:broadcaster:update:pause:status:error';
/** init room */
export const INIT_ROOM = 'ui:broadcaster:init:room';
/** setting broadcaster from firebase node */
export const SET_BROADCASTER_MODERATORS_IN_ROOM = 'ui:broadcast:set:moderators:in:room';
/** setting broadcaster silenced users from firebase */
export const SET_BROADCASTER_SILENCED_USERS_IN_ROOM = 'ui:broadcast:set:silenced:users:in:room';
/** setting broadcaster banned users from firebase */
export const SET_BROADCASTER_BANNED_USERS_IN_ROOM = 'ui:broadcast:set:banned:users:in:room';
/** setting moderation search error */
export const SET_BROADCASTER_MODERATION_ERROR_VALUE = 'ui:broadcast:set:moderation:error:value';
/** close broadcaster search */
export const CLOSE_BROADCASTER_SEARCH = 'ui:close:broadcast:search';
/** sets notes list response */
export const NOTES_LIST_RESPONSE = 'ui:broadcaster:notes:list:response';
/** set broadcaster search error */
export const SET_BROADCASTER_NOTES_SEARCH_ERROR_VALUE = 'ui:set:broadcaster:notes:search:error:value';
/** emits when broadcaster create or update note */
export const NOTE_UPDATED_OR_CREATED = 'ui:note:updated:or:created';
/** broadcaster note delete */
export const BROADCASTER_NOTE_DELETED = 'ui:note:broadcaster:note:deleted';
/** broadcaster single note object */
export const SINGLE_NOTE_RESPONSE = 'ui:single:broadcaster:note:response';
/** broadcaster new note view */
export const SET_NEW_NOTE_VIEW = 'ui:set:new:note:view';
/** broadcaster reset success view note */
export const RESET_SUCCESS_NOTE_VIEW = 'ui:reset:success:note:view';
/** top tippers data returned from getLeaderboard api call in Streaming Service */
export const TIPPERS_LEADERBOARD_DATA = 'ui:broadcast:tippers:leaderboard:response';
export const LIVE_TOUCH_QR_CODE_TOKEN = 'ui:broadcast:live:touch:qr:code:generator:token';
/** set friend requests */
export const FRIEND_REQUESTS_RESPONSE = 'ui:broadcaster:friend:requests:response';
/** setting friend status */
export const FRIEND_STATUS_RESPONSE = 'ui:broadcaster:friend:status:response';
/** setting favorite status */
export const FAVORITE_STATUS_RESPONSE = 'ui:broadcaster:favorite:status:response';
/** response we get from getting ps settings */
export const BROADCASTER_PRIVATE_SHOW_SETTINGS = 'ui:broadcaster:get:ps:settings:response';
/** response for profile info - used for getting private show viewer rating */
export const PROFILE_INFO_RESPONSE = 'ui:broadcaster:profile:info:response';
/** update all notes object */
export const UPDATE_ALL_NOTES = 'ui:broadcaster:update:all:notes';
/** setting all notes */
export const ALL_NOTES_RESPONSE = 'ui:broadcaster:all:user:notes:response';
/** setting all notes counts */
export const UPDATE_ALL_NOTES_COUNT = 'ui:broadcaster:update:all:notes:count';
/** set room loading status */
export const ROOM_LOADING_STATUS = 'ui:broadcaster:room:loading:status';
/** set device error */
export const SET_DEVICE_ERROR = 'ui:broadcaster:set:device:error';
/** emitted when stream is resumed */
export const STREAM_RESUME_SUCCESS = 'ui:broadcaster:stream:resume:success';
/** ticket selling started */
export const TICKET_SELLING_STARTED = 'ui:broadcaster:ticket:selling:started';
/** ticket selling failed */
export const TICKET_SELLING_FAILED = 'ui:broadcaster:ticket:selling:failed';
/** triggered when gs updated or ended */
export const UPDATE_GS_SUCCESS = 'ui:broadcaster:update:gs:success';
/** triggered when game is started or ended */
export const GAME_ACTION_DONE = 'ui:broadcaster:game:action:done';
/** when game is saved */
export const GAME_SAVED = 'ui:broadcaster:game:saved';
/** trigers when online status is changed */
export const ONLINE_STATUS_CHANGED = 'ui:broadcaster:online:status:changed';
/** emits when there are no devices */
export const NO_DEVICES_ACCESSIBLE = 'ui:broadcaster:no:devices:accessible';
/** when mic is blocked */
export const MIC_BLOCKED = 'ui:broadcaster:mic:blocked';
export const NEW_NOTE_CREATED = 'ui:note:new:created';
export const RESET_SHOW_STATE = 'ui:broadcast:reset:show:state';
export const SHOULD_REINIT_BROADCAST = 'ui:broadcast:check:reinit';
export const FRIEND_REQUEST_HANDLED = 'ui:broadcaster:request:handled';
export const PRIVATE_SHOW_USER_NOT_IN_ROOM = 'ui:broadcaster:private:show:user:not:in:room';
export const UPDATE_VIDEO_DEVICE = 'ui:broadcaster:update:video:device';
export const UPDATE_AUDIO_DEVICE = 'ui:broadcaster:update:audio:device';
export const MIC_NOT_FOUND = 'ui:broadcaster:mic:not:found';
export const HIDE_CHAT_EXPAND_BUTTON = 'ui:broadcaster:hide:expand:button';
export const PRIVATE_ROOM_RESPONSE = 'ui:broadcaster:private:room:response';
export const SET_PAUSED_REMAINING_TIME = 'ui:broadcaster:set:paused:remaining:time';
export const SET_LOADING_WEBSERVER_TIME_REQUEST = 'ui:loading:webserver:time:request';
export const DISABLE_GAME = 'ui:broadcaster:disable:running:game';
export const ACCEPT_PRIVATE_SHOW_ERROR = 'ui:broadcaster:accept:private:show:error';

// TWITTER

export const TWITTER_ACCOUNT_INFO_RESPONSE = 'ui:broadcaster:twitter:status:response';
export const TWITTER_ACCOUNT_INFO_ERROR = 'ui:broadcaster:twitter:status:error';
export const TWITTER_TWEET_RESPONSE = 'ui:broadcaster:twitter:tweet:response';
export const TWITTER_TWEET_ERROR = 'ui:broadcaster:twitter:tweet:error';

/** setting ui variables from response */
export const UI_VARIABLES_RESPONSE = 'ui:variables:response';
/** setting private show info data */
export const SET_BROADCASTER_PRIVATE_SHOW_INFO = 'ui:variables:private:show:info:from:firebase';
/** response containing broadcaster private show ratings */
export const BROADCASTER_PS_RATINGS = 'ui:broadcaster:get:ps:ratings:response';
/** setting original username that participates private show on broadcaster side */
export const SET_ORIGINAL_USERNAME_INSIDE_PRIVATE_SHOW = 'ui:set:broadcaster:side:user:username:inside:private:show';

/** receiving a user offline notification */
export const USER_OFFLINE_NOTIFICATION_RECEIVED = 'ui:user:notification:received';

/** after loading initial chat messages */
export const LOAD_INITIAL_CHAT_MESSAGES = 'ui:chat:load:initial:messages';

export const INITIAL_MESSAGE_TRANSLATION = 'ui:chat:initial:mesage:translation';

export const PUBLIC_MESSAGE_SENT = 'ui:chat:message:sent:public';

/** after a chat messages was received */
export const CHAT_MESSAGE_RECEIVED = 'ui:chat:message:received';

export const CHAT_TRANSLATION_SETTINGS_UPDATED = 'ui:chat:translations:settings:updated';
